import { storeToRefs } from "pinia";
import { shoppingCartStore } from "@stores/shopping_cart_store.js";
import Swal from "sweetalert2";
import {
  encriptar,
  desencriptar,
  encriptarCampo,
} from "@composables/use_encript.js";
import { useRouter } from "vue-router";
export const useShoppingCartStore = () => {
  const myShoppingCartStore = shoppingCartStore();

  const router = useRouter();

  const {
    loadingShoppingCart,
    showShoppingCart,
    shoppingCartItems,
    shoppingCartItemCount,
    shoppingCartTotal,
    idVenta,
    tipoPago,
    preferenceId,
    showCancelarVenta,
  } = storeToRefs(myShoppingCartStore);

  const initShoppingCart = async () => {
    await myShoppingCartStore.initShoppingCart();
  };

  const expiredCheck = async () => {
    await myShoppingCartStore.expiredCheck();
  };

  const toggleShoppingCartModal = () => {
    myShoppingCartStore.toggleShoppingCartModal();
  };

  const showShoppingCartModal = () => {
    myShoppingCartStore.showShoppingCartModal();
  };

  const hideShoppingCartModal = () => {
    myShoppingCartStore.hideShoppingCartModal();
  };

  const resetShoppingCart = async () => {
    await myShoppingCartStore.resetShoppingCart();
  };

  const addToShoppingCart = async (product) => {
    await myShoppingCartStore.addToShoppingCart(product);
    await myShoppingCartStore.updateData();
  };

  const removeFromShoppingCart = async (product) => {
    await myShoppingCartStore.removeFromShoppingCart(product);
    await myShoppingCartStore.updateData();

    if (shoppingCartItems.value.length == 0) {
      myShoppingCartStore.hideShoppingCartModal();
    }
  };

  const updateShoppingCart = async (
    product,
    qtty,
    ppId,
    Presentacion,
    PreciosPresentacion
  ) => {
    await myShoppingCartStore.updateShoppingCart(
      product,
      qtty,
      ppId,
      Presentacion,
      PreciosPresentacion
    );
    await myShoppingCartStore.updateData();
    //cartel de disponibilidad
    let availables = document.querySelectorAll(".available_vw");
    let showed = 0;
    availables.forEach((item) => {
      const el = document.getElementById(`ava_${item.dataset.ppId}`);
      const elParentElement = el.parentElement;
      const estilo = window.getComputedStyle(el);
      const estiloParentElement = window.getComputedStyle(elParentElement);
      if (estiloParentElement.display !== "none" && estilo.display !== "none") {
        showed++;
      }
    });

    if (showed == 0) {
      document.getElementById("msgNoDisponibilidad")?.classList.add("d-none");
    } else {
      document
        .getElementById("msgNoDisponibilidad")
        ?.classList.remove("d-none");
    }
  };

  const validateProduct = async (data) => {
    let itemVerified = await myShoppingCartStore.validateProduct(data);
    return itemVerified;
  };

  const processCart = async (data) => {
    initShoppingCart();
    var preferenceId_value =
      desencriptar(localStorage.getItem(encriptarCampo("preferenceId"))) !== ""
        ? desencriptar(localStorage.getItem(encriptarCampo("preferenceId")))
        : "";
    if (preferenceId_value == "") {
      let response = await chequearStock(data);
      if (response) {
        modalPagos(data);
      }
    } else {
      let cartModified =
        desencriptar(localStorage.getItem(encriptarCampo("cartModified"))) !==
          ""
          ? desencriptar(localStorage.getItem(encriptarCampo("cartModified")))
          : "false";
      let idVenta =
        desencriptar(localStorage.getItem(encriptarCampo("saleId"))) !== ""
          ? desencriptar(localStorage.getItem(encriptarCampo("saleId")))
          : "";
      if (cartModified == "true") {
        alert(
          "El Carrito de compras ha sido modificado, procediendo a actualizar la venta"
        );
        let response = await chequearStock(data);
        if (response) {
          modalPagos(data, idVenta);
        }
        localStorage.setItem(
          encriptarCampo("cartModified"),
          encriptar("false")
        );
      } else {
        modalPagos(data);
      }
    }
  };

  const chequearStock = async (data) => {
    document.getElementById("btnMP").classList.add("disabled");
    document.getElementById("btnOtrosPagos").classList.add("disabled");

    let itemVerified = await myShoppingCartStore.processCart(data);

    if (itemVerified) {
      let valid = true;
      itemVerified.forEach((item) => {
        if (item.isEnough == false) {
          valid = false;
        }
      });
      if (valid) {
        document.getElementById("loadingText").innerHTML =
          "Chequeo de disponibilidad de productos realizada. Procediendo a realizar la venta.";
        document.getElementById("msgNoDisponibilidad").classList.add("d-none");
        return true;
      } else {
        alert(
          "No hay suficiente stock de algunos de los productos agregados al carrito. Por favor, revisa la lista de productos que agregaste al carrito y cambia la cantidad de aquellos que están indicados en color amarillo. Se informa la cantidad máxima disponible que puedes comprar."
        );
        document
          .getElementById("msgNoDisponibilidad")
          .classList.remove("d-none");
        restablecerLoadingBotones();
        await myShoppingCartStore.mostrarDisponibilidad(itemVerified);
        return false;
      }
    } else {
      restablecerLoadingBotones();
    }
  };

  const modalPagos = async (data, idVenta = "") => {
    var tipoPago = data.tipoPago;
    if (tipoPago == "OtrosMedios") {
      Swal.fire({
        title: "Método de Pago",
        text: "Al pagar en efectivo o por transferencia, te estaremos contactando para verificar el pago, antes de entregarte la compra.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dd2736",
        cancelButtonColor: "#000000",
        confirmButtonText: "Pagar en efectivo o transferencia",
        cancelButtonText: "Cancelar",
        didOpen: () => {
          const confirmButton = Swal.getConfirmButton();
          if (confirmButton) {
            confirmButton.addEventListener("click", () => {
              confirmButton.disabled = true;
              confirmButton.style.opacity = "0.5";
              confirmButton.style.cursor = "not-allowed";
            });
          }
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          var preferenceId =
            desencriptar(
              localStorage.getItem(encriptarCampo("preferenceId"))
            ) !== ""
              ? desencriptar(
                localStorage.getItem(encriptarCampo("preferenceId"))
              )
              : "";
          var idVenta =
            desencriptar(localStorage.getItem(encriptarCampo("saleId"))) !== ""
              ? desencriptar(localStorage.getItem(encriptarCampo("saleId")))
              : "";

          if (idVenta != "") {
            data.cliente = getCliente();
            data.email = getEmail();
            data.ventaId = idVenta;
            actualizarVenta(data);
            restablecerLoadingBotones();
          }

          if (preferenceId != "") {
            //Cambiar metodo de pago
            if (
              confirm(
                "Tiene una venta por pagar con Mercado Pago, ¿está seguro(a) que desea cambiar el método de Pago?"
              )
            ) {
              var idVenta =
                desencriptar(localStorage.getItem(encriptarCampo("saleId"))) !==
                  ""
                  ? desencriptar(localStorage.getItem(encriptarCampo("saleId")))
                  : "";

              data = {
                email: getEmail(),
                ventaId: idVenta,
                tipoPago: "OtrosMedios",
              };

              cambiarMetodoPago(data);
            } else {
              restablecerLoadingBotones();
              return false;
            }
          } else {
            //Nueva venta
            data.cliente = getCliente();
            data.email = getEmail();

            let response = await nuevaVenta(data);

            if (response) {
              Swal.fire({
                text: "Venta realizada exitosamente",
                confirmButtonColor: "#000000",
                icon: "success",
              });
              localStorage.setItem(
                encriptarCampo("basterShopingCart"),
                JSON.stringify(encriptar([]))
              );
              myShoppingCartStore.toggleShoppingCartModal();
              const dominioURL = window.location.href;
              var soloPirotecnia = dominioURL.includes("?pirotecnia");
              if (soloPirotecnia) {
                router.push("/?pirotecnia");
              } else {
                router.push("/");
              }
            } else {
              restablecerLoadingBotones();
            }
          }
        } else {
          restablecerLoadingBotones();
        }
      });
    } else {
      // MERCADO PAGO
      var preferenceId_value =
        desencriptar(localStorage.getItem(encriptarCampo("preferenceId"))) !==
          ""
          ? desencriptar(localStorage.getItem(encriptarCampo("preferenceId")))
          : "";

      idVenta =
        desencriptar(localStorage.getItem(encriptarCampo("saleId"))) !== ""
          ? desencriptar(localStorage.getItem(encriptarCampo("saleId")))
          : "";
      if (idVenta != "") {
        data.cliente = getCliente();
        data.email = getEmail();
        data.ventaId = idVenta;
        let response = await actualizarVenta(data);

        if (response) {
          idVenta = response;
          tipoPago = tipoPago;
          modalMercardoPago();
          preferenceId_value = await myShoppingCartStore.MPButtonPay(
            data,
            response
          );
          localStorage.setItem(
            encriptarCampo("preferenceId"),
            encriptar(preferenceId_value)
          );
          restablecerLoadingBotones();
          return true;
        } else {
          restablecerLoadingBotones();
          return false;
        }
      } else {
        if (preferenceId_value != "") {
          // Ya se realizó la venta y se generó link de pago, cargarlo entonces...
          modalMercardoPago();
          await loadPayButtonGenerated(preferenceId_value);
          restablecerLoadingBotones();
        } else {
          // No se ha realizado la venta. Se hace la venta y se genera link de pago...
          data.cliente = getCliente();
          data.email = getEmail();
          let response = await nuevaVenta(data);
          if (response) {
            idVenta = response;
            tipoPago = tipoPago;

            modalMercardoPago();
            preferenceId_value = await myShoppingCartStore.MPButtonPay(
              data,
              response
            );

            localStorage.setItem(
              encriptarCampo("preferenceId"),
              encriptar(preferenceId_value)
            );
            restablecerLoadingBotones();
          } else {
            restablecerLoadingBotones();
            return false;
          }
        }
      }
    }
  };

  const modalMercardoPago = () => {
    let htmlMessage =
      '<div id="divPagoMPModal" style="color: red; background-color: cornsilk"' +
      'class="text-left text-danger rounded p-1 mb-2">' +
      "<small>⏱️ Retiro del pedido<br/>" +
      "Una vez acreditado el pago, la preparación puede demorar entre 24 y 48 horas, según la demanda del momento." +
      "<br/>Cuando tu pedido esté listo para retirar, un asistente se comunicará con vos para confirmarlo." +
      "</small>" +
      '<div id="spinnerModal"><div class="spinner-border mt-1 ml-2" role="status">' +
      '<span class="sr-only"></span></div><span class="small px-3"><em>Cargando enlace para el Pago</em></span></div>' +
      '<div class="py-2" id="mercadoPagoSpan" style="display: flex;flex-direction: column;align-items: center;justify-content: center;">' +
      '<form method="POST" class="text-center" id="payForm"></form>' +
      "</div>" +
      "</div>";

    Swal.fire({
      title: "Método de Pago",
      html: htmlMessage,
      icon: "warning",
      showConfirmButton: false,
      showCancelButton: true,
      cancelButtonColor: "#000000",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isDismissed) {
        var preferenceId =
          desencriptar(localStorage.getItem(encriptarCampo("preferenceId"))) !=
            ""
            ? desencriptar(localStorage.getItem(encriptarCampo("preferenceId")))
            : "";

        if (preferenceId != "") {
          let btnCancelarVenta = document.getElementById("btnCancelarVenta");
          if (!btnCancelarVenta) {
            let btnCancelarVentaDimissed = document.getElementById(
              "btnCancelarVentaDimissed"
            );
            if (btnCancelarVentaDimissed) {
              btnCancelarVentaDimissed.classList.remove("d-none");
            }
          }
        }
        return false;
      }
    });
  };

  const loadPayButtonGenerated = async (preferenceId) => {
    const mlScript = document.createElement("script");
    mlScript.dataset.preferenceId = preferenceId;
    mlScript.src =
      "https://www.mercadopago.com.ar/integrations/v1/web-payment-checkout.js";
    document.querySelector("#payForm").append(mlScript);
    mlScript.addEventListener("load", (event) => {
      document.getElementById("spinnerModal").classList.add("d-none");
      document
        .getElementsByClassName("mercadopago-button")[0]
        .addEventListener("mousedown", (event) => {
          event.preventDefault;
          myShoppingCartStore.toggleShoppingCartModal();
          localStorage.setItem(
            encriptarCampo("basterShopingCart"),
            JSON.stringify(encriptar([]))
          );
          localStorage.setItem(encriptarCampo("saleId"), encriptar(""));
          localStorage.setItem(encriptarCampo("preferenceId"), encriptar(""));
          localStorage.setItem(
            encriptarCampo("cartModified"),
            encriptar("false")
          );
        });
    });
  };

  const nuevaVenta = async (data) => {
    return await myShoppingCartStore.nuevaVenta(data);
  };

  const actualizarVenta = async (data) => {
    return await myShoppingCartStore.actualizarVenta(data);
  };

  const setTipoPago = () => {
    myShoppingCartStore.setTipoPago(data);
  };

  const getCliente = () => {
    if (typeof Storage !== undefined) {
      return desencriptar(localStorage.getItem(encriptarCampo("cliente"))) !==
        ""
        ? desencriptar(localStorage.getItem(encriptarCampo("cliente")))
        : null;
    } else {
      return alert("Almacenamiento local no disponible!!!");
    }
  };

  const getEmail = () => {
    if (typeof Storage !== undefined) {
      return desencriptar(localStorage.getItem(encriptarCampo("email"))) !== ""
        ? desencriptar(localStorage.getItem(encriptarCampo("email")))
        : null;
    } else {
      return alert("Almacenamiento local no disponible!!!");
    }
  };

  const restablecerLoadingBotones = () => {
    document.getElementById("loading").classList.add("d-none");
    document.getElementById("loadingText").innerHTML = "";
    document.getElementById("btnMP").classList.remove("disabled");
    document.getElementById("btnOtrosPagos").classList.remove("disabled");

    let confirmBtn = document.querySelector(".swal2-confirm");
    if (confirmBtn) confirmBtn.classList.add("disabled");
  };

  const cancelarVenta = async (data) => {
    return await myShoppingCartStore.cancelarVenta(data);
  };

  const cambiarMetodoPago = async (data) => {
    let response = await myShoppingCartStore.cambiarMetodoPago(data);
    if (response) {
      alert("Compra " + response.id + " pagada con Otros Medios de Pago");
      myShoppingCartStore.setTipoPago("OtrosMedios");
      localStorage.setItem(
        encriptarCampo("basterShopingCart"),
        JSON.stringify(encriptar([]))
      );
      myShoppingCartStore.resetShoppingCart();
      const dominioURL = window.location.href;
      var soloPirotecnia = dominioURL.includes("?pirotecnia");
      if (soloPirotecnia) {
        router.push("/?pirotecnia");
      } else {
        router.push("/");
      }
    }
  };

  return {
    ///* properties
    loadingShoppingCart,
    showShoppingCart,
    shoppingCartItems,
    shoppingCartItemCount,
    shoppingCartTotal,
    idVenta,
    tipoPago,
    preferenceId,
    showCancelarVenta,

    ///* methods
    initShoppingCart,
    expiredCheck,
    toggleShoppingCartModal,
    showShoppingCartModal,
    hideShoppingCartModal,
    resetShoppingCart,
    addToShoppingCart,
    removeFromShoppingCart,
    updateShoppingCart,
    processCart,
    validateProduct,
    nuevaVenta,
    cancelarVenta,
    cambiarMetodoPago,
  };
};
